import "#legacy/admin/page_builder/tool.js";
import "#legacy/admin/page_builder/modals/list_editor.js";

/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function () {
  "use strict";

  Sparkle.PageBuilder.Tool({
    name: "list-editor",
    templateId: "list-editor-template",

    /**
     * @name bind
     * @description
     * Bind the different event listeners to the component
     * @param {HTMLElement} component
     */
    bind: function (component) {
      jQuery(this.element).on("click", "button", initListBuilder);

      function initListBuilder() {
        var config = component.config.attributes[component.name];

        if (component.context) {
          var entityType = component.context.entity_type;
          var categoryId = component.context.category_id;
        }

        var modal = new Sparkle.PageBuilder.Modal.ListEditor({
          entityItems: config.entity_type.select_items,
          categoryId: categoryId || "",
          entityType: entityType || config.entity_type.default,
          onComplete: updateComponent,
        });
        modal.show();
      }

      // HELPERS
      function updateComponent(listValues) {
        component.save(listValues);
        component.render();
      }
    },

    /**
     * @name bind
     * @description
     * Unbind the different event listeners to the component added during the
     *  initial bind step.
     * @param {HTMLElement} element
     */
    unbind: function () {
      jQuery(this.element).find("button").off("change");
    },
  });
})();
